import { Injectable, Type } from '@angular/core';

import { ParserBase } from '../../bases';

@Injectable()
export class ParserFactory {
  registery: ParserBase<any, any>[];
  constructor() {
    this.registery = [];
  }
  register<TModel, TPresenter>(parser: ParserBase<TModel, TPresenter>): void {
    const _model = new parser.modelType();
    const _presenter = new parser.presenterType();
    if (
      !this.registery.find(
        (_parser) =>
          _model instanceof _parser.modelType &&
          _presenter instanceof _parser.presenterType &&
          _parser.version === parser.version,
      )
    ) {
      this.registery.push(parser);
    }
  }
  getParsers<TModel, TPresenter>(
    modelType: Type<TModel>,
    presenterType: Type<TPresenter>,
  ): ParserBase<TModel, TPresenter>[] {
    const _model = new modelType();
    const _presenter = new presenterType();

    const parsers = this.registery.filter(
      (_parser) =>
        _model instanceof _parser.modelType &&
        _presenter instanceof _parser.presenterType,
    );

    return parsers;
  }

  getParser<TModel, TPresenter>(
    modelType: Type<TModel>,
    presenterType: Type<TPresenter>,
    version = 0,
  ): ParserBase<TModel, TPresenter> {
    const _model = new modelType();
    const _presenter = new presenterType();

    const parser = this.registery.find(
      (_parser) =>
        _model instanceof _parser.modelType &&
        _presenter instanceof _parser.presenterType &&
        _parser.version === version,
    );

    if (!parser) {
      throw new Error(
        `No parser registered for <${modelType.name}, ${presenterType.name}> with version: ${version}`,
      );
    }

    return parser;
  }
}
